// src/utils/scrollTo.js
// Smoothly scrolls to a section by its id with nav offset

export default function scrollTo(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const navHeight = 72; // matches nav height in nav.css
  const top = el.getBoundingClientRect().top + window.scrollY - navHeight;
  window.scrollTo({ top, behavior: 'smooth' });
}
